export class UploadResponse {
  resType: UploadProgressType;
  content: any;
}

export enum UploadProgressType {
  'BODY' = 0,
  'PROGRESS' = 1
}
